import { FC } from 'react';
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Stack,
  Text,
} from '@chakra-ui/react';

import { PiiApprovalFragment } from '../../graphql/generated';
import { formatTimestamp } from '../../utils/date/date';
import { Property } from '../property/property';

type PiiApprovalsListProps = {
  approvals: PiiApprovalFragment[];
};

export const PiiApprovalsList: FC<PiiApprovalsListProps> = ({ approvals }) => {
  if (approvals.length === 0) return null;

  return (
    <Property label="PII approvals" testId="approved-by">
      <Accordion defaultIndex={[0, 1]} allowMultiple>
        {approvals.map((approval) => (
          <AccordionItem key={approval.approver.email} border={0}>
            <AccordionButton
              pl={0}
              gridGap={4}
              width="inherit"
              _focus={{ outline: 0 }}
            >
              <Box textAlign="left" fontWeight="500">
                <Text data-testid="pii-approver">
                  {approval.approver.name} ({approval.approver.email})
                </Text>
              </Box>
              <AccordionIcon />
            </AccordionButton>
            <AccordionPanel pl={2} pb={4}>
              <Stack spacing="3" data-testid="file-properties">
                <Property label="Comments" testId="pii-approval-comments">
                  {approval.comment}
                </Property>
                <Property label="Approved at" testId="pii-approved-at">
                  {formatTimestamp(approval.approvedAt)}
                </Property>
              </Stack>
            </AccordionPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </Property>
  );
};
